(() => {
  const SIZE_ORDER = [
    "xxs",
    "xs",
    "xs/s",
    "s",
    "s/m",
    "m",
    "m/l",
    "l",
    "xl",
    "xxl",
    "xxxl",
    "one size",
    "one-size",
    "universal",
    "uniwersalny"
  ];

  const normalizeSize = (value) =>
    value
      .trim()
      .toLowerCase()
      .replace(/\s*\/\s*/g, "/")
      .replace(/\s+/g, " ");

  const sizeRank = (value) => {
    const normalized = normalizeSize(value);
    const index = SIZE_ORDER.indexOf(normalized);
    return index === -1 ? SIZE_ORDER.length : index;
  };

  const sortSizeOptions = (root = document) => {
    root.querySelectorAll("[data-size-option]").forEach((fieldset) => {
      const group = fieldset.querySelector(".product-form__controls-group");
      if (!group || group.dataset.siteSizeSorted === "true") return;

      const items = Array.from(group.children);
      const pairs = [];

      for (let index = 0; index < items.length; index += 1) {
        const item = items[index];
        if (item.matches("input")) {
          const label = items[index + 1]?.matches("label") ? items[index + 1] : null;
          pairs.push({ nodes: label ? [item, label] : [item], label: item.value });
          if (label) index += 1;
        } else if (item.matches("li")) {
          const input = item.querySelector("input");
          pairs.push({ nodes: [item], label: input?.value || item.textContent });
        }
      }

      if (pairs.length < 2) return;

      pairs
        .sort((a, b) => {
          const rankDifference = sizeRank(a.label) - sizeRank(b.label);
          if (rankDifference !== 0) return rankDifference;
          return normalizeSize(a.label).localeCompare(normalizeSize(b.label), undefined, {
            numeric: true
          });
        })
        .forEach((pair) => pair.nodes.forEach((node) => group.appendChild(node)));

      group.dataset.siteSizeSorted = "true";
    });
  };

  const initDescriptionToggles = (root = document) => {
    root.querySelectorAll("[data-product-description-toggle]").forEach((button) => {
      if (button.dataset.siteConnected === "true") return;
      const description = document.getElementById(button.getAttribute("aria-controls"));
      if (!description) return;

      const updateVisibility = () => {
        const isOverflowing = description.scrollHeight > description.clientHeight + 2;
        button.classList.toggle("is-hidden", !isOverflowing);
      };

      button.addEventListener("click", () => {
        description.classList.add("is-open");
        button.setAttribute("aria-expanded", "true");
      });

      button.dataset.siteConnected = "true";
      requestAnimationFrame(updateVisibility);
    });
  };

  const mobileGalleryMedia = window.matchMedia("(max-width: 749px)");
  let mobileGalleryFrame;

  const alignMobileGalleryToLogo = () => {
    window.cancelAnimationFrame(mobileGalleryFrame);
    mobileGalleryFrame = window.requestAnimationFrame(() => {
      const section = document.querySelector(
        ".template-product .shopify-section:first-child.product-section"
      );

      if (!section) return;

      section.style.removeProperty("--site-mobile-gallery-offset");
      if (!mobileGalleryMedia.matches) return;

      const logo = Array.from(
        document.querySelectorAll(
          ".shopify-section-header:not(.shopify-section-header-sticky) .header__heading-logo:not(.header__heading-logo--overlay)"
        )
      ).find((item) => {
        const rect = item.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
      });
      const gallery = section.querySelector(
        ".product__media-wrapper, [data-gallery-container]"
      );

      if (!logo || !gallery) return;

      const currentMargin = Number.parseFloat(
        window.getComputedStyle(section).marginTop
      ) || 0;
      const targetTop = logo.getBoundingClientRect().top - 3;
      const galleryTop = gallery.getBoundingClientRect().top;
      const correctedMargin = currentMargin + targetTop - galleryTop;

      if (Number.isFinite(correctedMargin)) {
        section.style.setProperty(
          "--site-mobile-gallery-offset",
          `${Math.round(correctedMargin * 10) / 10}px`
        );
      }
    });
  };

  const init = (root = document) => {
    sortSizeOptions(root);
    initDescriptionToggles(root);
    alignMobileGalleryToLogo();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("quickadd:loaded", (event) => init(event.target || document));
  window.addEventListener("load", alignMobileGalleryToLogo);
  window.addEventListener("resize", alignMobileGalleryToLogo, { passive: true });
  mobileGalleryMedia.addEventListener?.("change", alignMobileGalleryToLogo);
})();
